import { ChevronUpIcon } from "@heroicons/react/solid";
import { classNames } from "../../helpers";
import ShowIf from "../show-if/ShowIf";

export enum SortDirection {
  ascending = "ascending",
  descending = "descending",
}

type TableHeaderCellProps = {
  className?: string;
  sortable?: boolean;
  sortingDirection?: SortDirection;
  onClick?: () => void;
  textPosition?: "start" | "center" | "end";
};
const TableHeaderCell: React.FC<TableHeaderCellProps> = ({
  className,
  children,
  sortable,
  sortingDirection,
  textPosition = "start",
  onClick = () => {},
}) => {
  return (
    <th
      scope="col"
      className={classNames(
        "group px-4 py-2 table-cell",
        "leading-[0.05em] text-xs font-semibold text-gray-500",
        sortable && "cursor-pointer",
        className
      )}
      onClick={onClick}
    >
      <div className={`flex justify-${textPosition}`}>
        <div
          className={classNames(sortable && "flex items-center gap-2 w-fit")}
        >
          {children}
          <ShowIf condition={!!sortable}>
            <span
              className={classNames(
                "flex-none rounded",
                !!sortingDirection
                  ? "text-gray-500 bg-gray-100 group-hover:bg-gray-200"
                  : "text-gray-400 invisible group-hover:visible group-focus:visible"
              )}
            >
              <ChevronUpIcon
                className={classNames(
                  "h-4 w-4",
                  sortingDirection === SortDirection.descending && "rotate-180"
                )}
                aria-hidden="true"
              />
            </span>
          </ShowIf>
        </div>
      </div>
    </th>
  );
};
export default TableHeaderCell;
